import "reflect-metadata";
import {inject, injectable} from "inversify";
import {ReportTicketComparativeRepository} from "@dropDesk/domain/repositories/reports/report_ticket_comparative/report_ticket_comparative.repository";
import {ReportEntityFilters} from "@dropDesk/presentation/components/filters/report_entity_filters";

@injectable()
export class ExportHtmlReportTicketComparativeUseCase {
    private _repository: ReportTicketComparativeRepository;

    constructor(@inject(ReportTicketComparativeRepository) repository: ReportTicketComparativeRepository) {
        this._repository = repository;
    }

    public call(
        period: { startDate: string, endDate: string },
        comparePeriod: { compareStartDate: string, compareEndDate: string },
        filters?: ReportEntityFilters
    ): Promise<void> {
        return this._repository.exportHtml(period, comparePeriod, filters);
    }
}
